import { AssetRecordType, Editor } from '@tldraw/tldraw'
import { BackgroundAssetProps } from './Types'
import { getCurrentFrame } from 'components/VisualStudioPlayground/VisualEditor/helpers'
import { ImageShapeUtil } from 'components/VisualStudioPlayground/Shapes/ImageShape/ImageShapeUtil'

/**
 * Create a background image in the current frame.
 *
 * @param editor - The editor instance
 * @param assetProps - The asset properties
 * @returns void
 */
export const createBackground = (editor: Editor, assetProps: BackgroundAssetProps) => {
  const currentFrame = getCurrentFrame(editor)
  const asset = AssetRecordType.create({
    type: 'image',
    typeName: 'asset',
    props: {
      name: assetProps.src,
      isAnimated: false,
      ...assetProps,
    },
  })
  editor.batch(() => {
    editor.createAssets([asset])
    const imageShapeUtil = editor.getShapeUtil('image') as ImageShapeUtil
    imageShapeUtil.createAsBackground(currentFrame.id, asset.id)
  })
}
